import CurrentUserDetail from '../model/currentuser/CurrentUserDetail';
import UserRole from '../model/currentuser/UserRole';
import PrispevokVestnika from '../model/PrispevokVestnika';

export const isOwnVestnikOrganization = (
  pouzivatel: CurrentUserDetail,
  prispevokVestnika: PrispevokVestnika,
): boolean => pouzivatel?.roles?.includes(UserRole.REZORTNE_ZBIERKY_SPRAVCA)
    || prispevokVestnika?.vestnik?.uuid === pouzivatel?.organizaciaCiselnikyUuid;
